import { useLayoutEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  buSlugParam,
  comSlugParam,
  corpSlugParam,
  personalSlugParam,
} from "routes/constants";

export const useGetEntityParams = () => {
  const params = useParams();
  const [entityParams, setEntityParams] =
    useState<Array<{ key: string; value: string }>>();

  useLayoutEffect(() => {
    setEntityParams(() => {
      const tmpEntityParams = [];
      if (params?.[comSlugParam]) {
        tmpEntityParams.push({
          key: comSlugParam,
          value: params?.[comSlugParam] || "",
        });
      }

      if (params?.[buSlugParam]) {
        tmpEntityParams.push({
          key: buSlugParam,
          value: params?.[buSlugParam] || "",
        });
      }

      if (params?.[corpSlugParam]) {
        tmpEntityParams.push({
          key: corpSlugParam,
          value: params?.[corpSlugParam] || "",
        });
      }

      if (params?.[personalSlugParam]) {
        tmpEntityParams.push({
          key: personalSlugParam,
          value: params?.[personalSlugParam] || "",
        });
      }

      return tmpEntityParams;
    });
  }, [params]);

  return entityParams;
};
